// @flow
import * as React from "react";
import { Header, Grid, Responsive } from "semantic-ui-react";

type Props = {
  headerString: ?string | React.Node,
  children: any,
  textAlign?: string,
  forceMobile?: boolean,
  leftCompact?: boolean,
};

class GridRowReusable extends React.PureComponent<Props> {
  render() {
    if (this.props.forceMobile) {
      return (
        <Grid.Row>
          <Grid.Column width={16} className={this.props.leftCompact ? "grid-row-compact" : ""}>
            <Header textAlign={this.props.leftCompact ? "left" : "center"} as={"h4"}>
              {this.props.headerString}
            </Header>
          </Grid.Column>
          <Grid.Column width={16}>{this.props.children}</Grid.Column>
        </Grid.Row>
      );
    }

    return (
      <Grid.Row>
        <Grid.Column mobile={4} tablet={4} computer={3}>
          <Responsive minWidth={Responsive.onlyTablet.minWidth}>
            <Header textAlign={"right"} as={"h4"}>
              {this.props.headerString}
            </Header>
          </Responsive>
          <Responsive {...Responsive.onlyMobile}>
            <Header textAlign={"center"} as={"h4"}>
              {this.props.headerString}
            </Header>
          </Responsive>
        </Grid.Column>
        <Grid.Column width={11}>{this.props.children}</Grid.Column>
      </Grid.Row>
    );
  }
}
export default GridRowReusable;
